import base32 = require("base32-crockford-browser");
import * as _ from "lodash";
export function makeDomId(uniqueString: string):string {
    return "id" + base32.encode(uniqueString);
}

// Shallowly merge a partial object into an object,
// exactly mimicing React.Component.setState semantics,
// and useful for getting around the type system limitations of typescript
export function merge<T, K extends keyof T>(partial: Partial<T>, obj: Partial<T>): T {
    // if (typeof Object.assign === "function") {
    //     return Object.assign(obj, partial);
    // }
    if (true) {
        for (let name in partial) {
            if (partial.hasOwnProperty(name)) {
                (<any>obj)[name] = partial[name];
            }
        }
        return <any>obj;
    }
}
export function pick<T, K extends keyof T>(o: T, ...keys: K[]): Pick<T, K> {
    return keys.reduce((acc, k) => { 
        if (o.hasOwnProperty(k)) {
            acc[k] = o[k];
        }
        return acc[k];
    }, {} as any);
}
export function handle_null<T, R>(maybe: T | null | undefined, fn: (just: T) => R, fallback: R) {
	if (!maybe) {
		return fallback;
	}		
	else {
		return fn(maybe);
	}
} 

export function clamp(val: number, min?: number, max?: number) {
   let maxxed = Math.min(val, max !== undefined ? max : val);
   return Math.max(val, min !== undefined ? min : maxxed);
}

/**
 * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
 * 
 * @param {String} text The text to be rendered.
 * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
 * 
 * @see http://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
 */
let canvas: HTMLCanvasElement = null;
export function getTextWidth(text: string, font: string, document: HTMLDocument) {
    // re-use canvas object for better performance
    if (!canvas) {
       canvas =  document.createElement("canvas")
    }
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
}




// WEBPACK FOOTER //
// ./src/code/Util.ts